import React, { useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { API_URL } from '../../actions';
import styles from './ExportModal.module.scss';
import Loader from '../Loader';

const ExportModal = () => {
  const salesPointsReducer = useSelector((d: any) => d.salesPointsReducer);
  const {
    filters,
  } = salesPointsReducer;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const token = localStorage.getItem('token');
  const downloadExport = async (): Promise<void> => {
    setIsLoading(true);
    const response = await axios.post(
      `${API_URL}/salespoints/export`,
      filters,
      {
        responseType: 'blob',
        headers: {
          Authorization: `${token}`,
        },
      },
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const a = document.createElement('a');
    a.href = url;
    a.download = 'export.xlsx';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    setIsLoading(false);
  };

  return (
    <div className={styles.container}>
      <h2>Exporter la base</h2>
      <div className={styles.content}>
        {isLoading
          ? <Loader />
          : <button
            type="button"
            onClick={() => downloadExport()}
          >
            Exporter
          </button>
        }
      </div>
    </div>
  );
};

export default ExportModal;
